export default __webpack_public_path__ + "static/climate-neutral-5f72be97336943fae711a43ff90e3c54.jpg";